import type { ApiCommand, ApiRequest } from './apiCommand';

interface GetEXIFEmbeddedImageURLInput {
  url: string;
  fileName: string;
  itemId: string;
}

interface GetEXIFEmbeddedImageURLOutput {
  message: string;
  downloadUrl: string;
  hasExifError?: boolean;
}

export class GetEXIFEmbeddedImageURLCommand implements ApiCommand<GetEXIFEmbeddedImageURLOutput> {
  constructor(private input: GetEXIFEmbeddedImageURLInput) { }

  request(): ApiRequest {
    return {
      linkName: 'getEXIFEmbeddedImageURL',
      pathParams: {},
      queryParams: {},
      method: 'POST',
      body: JSON.stringify(this.input),
    };
  }

  asOutput(body: unknown): GetEXIFEmbeddedImageURLOutput {
    return body as GetEXIFEmbeddedImageURLOutput;
  }
}
